<h1 matDialogTitle>Edit Syspro Order Line</h1>

<mat-dialog-content>
  <form class="dynamic-form" [formGroup]="form" style="width: 100%">
    <div fxLayout="row wrap" fxLayoutAlign="start start" fxFlexFill fxLayoutGap="16px grid">

      <mat-form-field fxFlex="10" width="100%">
        <mat-label>Line</mat-label>
        <input matInput style="text-align: right;" type="number" formControlName="lineNumber">
      </mat-form-field>

      <mat-form-field fxFlex="30" width="100%">
        <mat-label>Stock Code</mat-label>
        <input matInput type="text" formControlName="stockCode">
      </mat-form-field>

      <mat-form-field fxFlex="30" width="100%">
        <mat-label>Part Category</mat-label>
        <input matInput type="text" formControlName="partCategory">
      </mat-form-field>

      <mat-form-field fxFlex="30" width="100%">
        <mat-label>Lead Time</mat-label>
        <input matInput type="text" formControlName="leadTime">
      </mat-form-field>

      <mat-form-field fxFlex="100" width="100%">
        <mat-label>Description</mat-label>
        <input matInput type="text" formControlName="lineDescription">
      </mat-form-field>

      <mat-form-field fxFlex="100" width="100%">
        <mat-label>Additional Info</mat-label>
        <input matInput type="text" formControlName="lineDescription2">
      </mat-form-field>

      <mat-form-field fxFlex="15" width="100%">
        <mat-label>Qty</mat-label>
        <input matInput style="text-align: right;" type="number" formControlName="orderQty">
      </mat-form-field>

      <mat-form-field fxFlex="85" width="100%">
        <mat-label>Warehouse</mat-label>
        <mat-select formControlName="warehouseCode" (selectionChange)="warehouseChanged($event)">
          <mat-option *ngFor="let warehouse of warehouses" [value]="warehouse.warehouseCode">
            {{warehouse.warehouseDesc}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field fxFlex="15" width="100%">
        <mat-label>Avail. Qty</mat-label>
        <input matInput style="text-align: right;" type="number" formControlName="availableQty">
      </mat-form-field>

      <mat-form-field fxFlex="85" width="100%">
        <mat-label>Delivery Method</mat-label>
        <mat-select formControlName="deliveryMethodId">
          <mat-option *ngFor="let deliveryMethod of deliveryMethods" [value]="deliveryMethod.deliveryMethodId">
            {{deliveryMethod.deliveryMethodDesc}}
          </mat-option>
        </mat-select>
      </mat-form-field>

    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button matDialogClose>Cancel</button>
  <button mat-button (click)="save()">Save</button>
</mat-dialog-actions>
